import filter from 'lodash/filter';
import head from 'lodash/head';

export class AboutUsInTheNewsService {
	constructor($resource, ApiService, DateService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.dateService = DateService;
		this.inTheNewsResourceUrl = this.apiService.getResourceUrl('menus/InTheNews');
		this.inTheNewsDetailsResourceUrl = this.apiService.getResourceUrl('in-the-news/:content_id');

		this.inTheNewsResource = this.$resource(this.inTheNewsResourceUrl);
		this.inTheNewsDetailsResource = this.$resource(this.inTheNewsDetailsResourceUrl);
	}

	/* #################################### PUBLIC METHODS ######################################### */

	getInTheNewsDetails(details) {
		return {
			count: details.data.count,
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			details: this._getNewsDetailsObject(details.data.content),
			archive: this._getArchiveSlugUrl(details.data.content)
		};
	}

	getNewsDetailsById(id) {
		const promise = this.inTheNewsDetailsResource.get({ content_id: id }).$promise;

		return promise.then(details => this._getNewsDetailsObject(details.data.content))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getNewsDetails({ data }) {
		return {
			id: data.content_id,
			nextId: data.next_id,
			previousId: data.previous_id,
			title: data.title,
			description: data.description,
			slug: data.slug,
			newsDate: this.dateService.parseDateFromServerDate(data.news_date),
			createdAt: data.publish_at,
			createdBy: data.created_by
		};
	}

	/* #################################### PRIVATE METHODS ######################################### */

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getNewsDetailsObject(values) {
		let details = filter(values, ['name', 'InTheNews']);
		return _getContentData.call(this, head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				id: value.content_id,
				nextId: value.next_id,
				previousId: value.previous_id,
				title: value.title,
				description: value.description,
				slug: value.slug,
				newsDate: this.dateService.parseDateFromServerDate(value.news_date),
				createdAt: value.publish_at,
				createdBy: value.created_by
			}));
		}
	}

	_getArchiveSlugUrl(values) {
		let details = filter(values, ['name', 'Archive']);
		return head(details).value;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-in-the-news/about-us-in-the-news.service.js